const config = {
    id: 4,
    name: "标题",
    type: 1,
    module_code: "title",
    icon: "icon-tms-title",
    font_icon: "&#xe61a;",
    style_type: 1,
    link_type: 0,
    description: '',
    share_image: '',
    property_data: {
        background_color: "",
        h1: "主标题",
        h1_color: "#000000",
        h2: "副标题",
        h2_color: "#000000",
        choose_photo_left: "",
        choose_photo_right: "",
        background_type: 0,
        padding: 20
    }
};

export default config;